"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var core_1 = require("@athena-portal/core");
var MaintenanceBannerWidget_1 = require("../widgets/MaintenanceBannerWidget");
var LvFalconNavigatorWithArrowBackButtons_1 = require("./LvFalconNavigatorWithArrowBackButtons");
var services_1 = require("@falcon/services");
var TrustpilotWidget_1 = require("../components/TrustpilotWidget");
var journey_services_1 = require("@athena-portal/journey-services");
var LvAnnualMotorNavigator = /** @class */ (function (_super) {
    __extends(LvAnnualMotorNavigator, _super);
    function LvAnnualMotorNavigator(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickCancel = function () {
            // Consider using new approach with uistate.changes, see Edit car journey, FAL-38251
            if (_this.props.interaction.uistate.interactionChangesDetected && _this.settings.showUnsavedChangesModal) {
                _this.props.engine.setJourneyState({
                    showUnsavedChangesModal: true
                });
            }
            else {
                var cancellationUrl = _this.settings.cancellationUrl ? _this.interpolate(_this.settings.cancellationUrl) : "/dashboard";
                window.location.assign(cancellationUrl);
            }
        };
        _this.interpolate = function (str) {
            return str.replace('${agreementNumber}', _this.props.interaction.agreementNumber);
        };
        _this.showProgressBar = false;
        _this.showBackground = true;
        _this.clickPrev = _this.clickPrev.bind(_this);
        _this.clickNext = _this.clickNext.bind(_this);
        // @ts-ignore Does not exist in typedefs, but defined in journey defs
        _this.settings = _this.props.journey["navigatorSettings"] || {};
        return _this;
    }
    LvAnnualMotorNavigator.prototype.componentDidCatch = function (error, errorInfo) {
        this.journeyService.doBackendAction("log", this.props.interaction, {
            level: "ERROR",
            message: "JRE: exception: ".concat(error.message ? error.message : "", "\n                Interaction id: ").concat(this.props.interaction._id || "-", "\n                Product: ").concat(this.props.product || "-", "\n                Process: ").concat(this.props.process || "-", "\n                Page: ").concat(this.props.page && this.props.page.pageId, "\n                ComponentStack: ").concat(errorInfo.componentStack || "-", "\n                Stack: ").concat(error.stack || "-")
        }, false).subscribe();
    };
    LvAnnualMotorNavigator.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f;
        var renderPageTitleHeading = this.settings.pageTitleHeading !== false;
        var isFlow = services_1.resourcesHelper.THEME === "Flow";
        var containsStickyPrice = (_a = this.props.page) === null || _a === void 0 ? void 0 : _a.questions.some(function (e) { return e.type === "stickyPrice" || e.type === 'annualHomeStickyPrice'; });
        var stickyPricePadding = containsStickyPrice ? " padding-top-80-not-important" : "";
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [this.showBackground && ((0, jsx_runtime_1.jsx)("div", { className: "journey-bg", children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("img", { className: "waves", src: "/img/Flow-waves.svg", alt: "Journey background waves" }), (0, jsx_runtime_1.jsx)("img", { className: "clouds", src: "/img/Flow-clouds.svg", alt: "Journey background clouds" })] }) })), this.mapInteractionToDataLayer(), this.renderHeader(), (0, jsx_runtime_1.jsxs)("div", { className: "journey-content".concat(stickyPricePadding), children: [(0, jsx_runtime_1.jsx)("div", { className: "journey-arrow-header", children: (0, jsx_runtime_1.jsx)("div", { className: "journey-arrow-header-content", children: (0, jsx_runtime_1.jsx)(services_1.FalconNavigatorHeader, { back: {
                                        html: (_b = this.renderBackButtonTop()) !== null && _b !== void 0 ? _b : undefined
                                    }, title: {
                                        label: (_c = this.props.page) === null || _c === void 0 ? void 0 : _c.title,
                                        hidden: !this.props.page || !this.isTitleVisible() || !renderPageTitleHeading
                                    } }) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "journey-questions", children: [(((_d = this.props.page) === null || _d === void 0 ? void 0 : _d.pageId) !== "decline") && (this.props.process === 'nb' || this.props.process.startsWith("mta") || this.props.process === services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL) &&
                                    (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(MaintenanceBannerWidget_1.MaintenanceBannerWidget, { product: this.props.product }) }), this.renderJourneyBody()] }), ((_e = this.props.page) === null || _e === void 0 ? void 0 : _e.nextPage) && this.renderJourneyButtons(), (0, jsx_runtime_1.jsx)("div", { children: (((_f = this.props.page) === null || _f === void 0 ? void 0 : _f.pageId) === "viewAndEditRenewalProposalPage" && isFlow) && this.renderPartnerBanner() }), (0, jsx_runtime_1.jsx)("div", { className: "journey-arrow-buttons", children: (0, jsx_runtime_1.jsx)("div", { className: "journey-arrow-buttons-content", children: this.renderBackButtonBottom() }) })] }), this.renderFooter()] }));
    };
    LvAnnualMotorNavigator.prototype.isTitleVisible = function () {
        var _a, _b, _c;
        return (((_a = this.props.page) === null || _a === void 0 ? void 0 : _a.pageId) !== "decline")
            && (!!((_b = this.props.page) === null || _b === void 0 ? void 0 : _b.pageId) && !((_c = this.props.page) === null || _c === void 0 ? void 0 : _c.pageId.toLowerCase().includes("tierdecline")))
            && (this.props.process === 'nb' || this.props.process.startsWith("mta") || this.props.process === services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL);
    };
    LvAnnualMotorNavigator.prototype.renderCancelButton = function () {
        if (!this.props.page) {
            return null;
        }
        if (this.props.page.nextPage) {
            var cssClasses = "btn btn-back";
            return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: cssClasses, onMouseDown: this.skipDefault, onTouchStart: this.skipDefault, onClick: this.onClickCancel, id: "navigatorNext", children: "Cancel changes" }));
        }
        return null;
    };
    LvAnnualMotorNavigator.prototype.clickPrev = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isHardDecline, journeyState, declineReferrerPage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(window.location.href.includes("decline") && !window.location.href.includes("renewal"))) return [3 /*break*/, 4];
                        isHardDecline = journey_services_1.ConditionEvaluator.evaluateCondition(this.props.journey.displayConditions, "isHardDecline", this.props.interaction);
                        if (!isHardDecline) return [3 /*break*/, 1];
                        window.location.href = "/journey/init/product/AnnualMotorInsurance/process/mtcForced/presetPage/".concat(this.props.interaction._id);
                        return [3 /*break*/, 3];
                    case 1:
                        journeyState = this.props.engine.getJourneyState();
                        declineReferrerPage = journeyState.declineReferrerPage;
                        if (declineReferrerPage === "quoteSummary") {
                            declineReferrerPage = "quote";
                        }
                        this.props.engine.setJourneyState({
                            declineReferrerPage: undefined,
                        });
                        return [4 /*yield*/, this.props.engine.navigate(declineReferrerPage, false)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, Promise.resolve()];
                    case 4: return [4 /*yield*/, _super.prototype.clickPrev.call(this)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.props.engine.validate()];
                    case 6:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    LvAnnualMotorNavigator.prototype.renderPartnerBanner = function () {
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex py-4 w-100 justify-content-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "d-flex", children: (0, jsx_runtime_1.jsx)(TrustpilotWidget_1.default, {}) }), (0, jsx_runtime_1.jsx)("div", { className: "d-flex", children: (0, jsx_runtime_1.jsx)("img", { className: "mb-4 mt-4 defaqto-logo", src: "/img/DefaqtoLogo.svg", alt: "Defaqto logo", "aria-label": "Defaqto logo" }) })] }) }));
    };
    LvAnnualMotorNavigator.prototype.renderJourneyBody = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "journey-questions-body", children: (0, jsx_runtime_1.jsx)("div", { className: "journey-questions-body-content", children: this.props.children }) }));
    };
    LvAnnualMotorNavigator.prototype.renderJourneyButtons = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "journey-buttons", children: (0, jsx_runtime_1.jsxs)("div", { className: "journey-buttons-content", children: [this.renderNextButton(), this.renderCancelButton()] }) }));
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], LvAnnualMotorNavigator.prototype, "journeyService", void 0);
    return LvAnnualMotorNavigator;
}(LvFalconNavigatorWithArrowBackButtons_1.default));
exports.default = LvAnnualMotorNavigator;
//# sourceMappingURL=LvAnnualMotorNavigator.js.map